import {
  BotProperty,
  GroupedBotProperty,
} from '../../../../../../../BotProperties/components/Properties/types'
import { CustomMediaTypes } from '../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import { SelectOptionData } from '../../../../../../../Pi/types'
import { NodeMessageEditorProps } from '../../../types'
import { ExternalAction } from '../../Action/logic/types'

export enum MessageNodeActionTypes {
  Message = 'Message',
  Typing = 'Typing',
  UserInput = 'Property'
}

export type SendMessageNodeProps = NodeMessageEditorProps & {
  getLabels: () => { [key: number]: string }
  getProperties: () => Array<GroupedBotProperty>
  createNewLabel: (label: string) => Promise<{ index: number }>
  createNewProperty: (path: string, name: string, parent?: number) => Promise<Array<BotProperty>>
  usersOptions: () => Array<SelectOptionData>
  targetOptions: () => Array<SelectOptionData>
  targets: () => Array<{ id: number, login: string, title: string }>
  externalActions?: Array<ExternalAction>
}
